import axios from "axios";
import HttpHelper from "../helper/HttpHelper";

class OrderService {
  getAll(payload) {
    return axios.get(
      HttpHelper.API_URL + "/orders",
      { params: payload },
      HttpHelper.getHeader()
    );
  }

  getOne(id, payload) {
    return axios.get(
      HttpHelper.API_URL + "/orders/" + id,
      { params: payload },
      HttpHelper.getHeader()
    );
  }

  create(payload) {
    return axios.post(
      HttpHelper.API_URL + "/orders",
      payload,
      HttpHelper.getAuthHeader()
    );
  }
  createDetails(payload) {
    return axios.post(
      HttpHelper.API_URL + "/oder-details",
      payload,
      HttpHelper.getAuthHeader()
    );
  }

  update(id, payload) {
    return axios.put(
      HttpHelper.API_URL + "/orders/" + id,
      payload,
      HttpHelper.getAuthHeader()
    );
  }

  delete(id) {
    return axios.delete(
      HttpHelper.API_URL + "/orders/" + id,
      HttpHelper.getAuthHeader()
    );
  }
}

export default OrderService = new OrderService();
